import { makeEmptyFilters } from "./constants"

const STORAGE_KEY = "book.bundle_list_filters"
const DEFAULT_PER_PAGE = 15
const DATE_KEYS = ["dateRequest", "dateCheckin", "dateCheckout"]

const PARAM = {
  f: "bl_f",
  status: "bl_status",
  qf: "bl_qf",
  page: "bl_page",
  per: "bl_per",
}

const isEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b)

const safeParse = (str) => {
  if (!str) return null
  try {
    return JSON.parse(str)
  } catch {
    return null
  }
}

// В сохранённый вид попадает только то, что отличается от пустых фильтров.
const diffFromEmpty = (applied) => {
  const empty = makeEmptyFilters()
  const out = {}
  Object.keys(applied || {}).forEach((k) => {
    if (k === "displayResults") return
    if (!isEqual(applied[k], empty[k])) out[k] = applied[k]
  })
  return out
}

const reviveFilters = (diff) => {
  const base = makeEmptyFilters()
  const res = { ...base, ...diff }
  res.condition = { ...base.condition, ...(diff?.condition || {}) }

  for (const key of DATE_KEYS) {
    const range = { ...base[key], ...(diff?.[key] || {}) }
    for (const side of ["from", "to"]) {
      const v = range[side]
      if (typeof v === "string" && v) {
        const d = new Date(v)
        range[side] = Number.isNaN(d.getTime()) ? base[key]?.[side] ?? "" : d
      }
    }
    res[key] = range
  }

  res.displayResults = base.displayResults
  return res
}

// state -> { f, status, qf, page, per } (строки)
const serialize = ({ applied, activeStatus, quickFilter, page, perPage }) => {
  const out = {}
  const diff = diffFromEmpty(applied)

  if (Object.keys(diff).length) out.f = JSON.stringify(diff)
  if (activeStatus !== null && activeStatus !== undefined) out.status = String(activeStatus)
  if (quickFilter) out.qf = JSON.stringify(quickFilter)
  if (page > 1) out.page = String(page)
  if (perPage && perPage !== DEFAULT_PER_PAGE) out.per = String(perPage)

  return out
}

// { f, status, qf, page, per } -> state
const deserialize = (raw) => {
  const page = parseInt(raw?.page, 10)
  const per = parseInt(raw?.per, 10)
  const qf = safeParse(raw?.qf)

  return {
    applied: reviveFilters(safeParse(raw?.f) || {}),
    activeStatus: raw?.status ?? null,
    quickFilter: qf && qf.key ? qf : null,
    page: page > 0 ? page : 1,
    perPage: per > 0 ? per : DEFAULT_PER_PAGE,
  }
}

export const loadFilterState = () => {
  let raw = null

  try {
    const sp = new URLSearchParams(window.location.search)
    const hasUrlState = Object.values(PARAM).some((p) => sp.has(p))

    if (hasUrlState) {
      raw = {}
      Object.entries(PARAM).forEach(([k, p]) => {
        raw[k] = sp.get(p)
      })
    }
  } catch {
    // ignore
  }

  if (!raw) {
    try {
      raw = safeParse(window.localStorage.getItem(STORAGE_KEY))
    } catch {
      raw = null
    }
  }

  return deserialize(raw || {})
}

export const saveFilterState = (state) => {
  const out = serialize(state)

  try {
    const url = new URL(window.location.href)
    Object.values(PARAM).forEach((p) => url.searchParams.delete(p))
    Object.entries(out).forEach(([k, v]) => url.searchParams.set(PARAM[k], v))
    window.history.replaceState(window.history.state, "", url.toString())
  } catch {
    // ignore
  }

  try {
    const { page, ...forStorage } = out
    if (Object.keys(forStorage).length) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(forStorage))
    } else {
      window.localStorage.removeItem(STORAGE_KEY)
    }
  } catch {
    // ignore
  }
}
